import moment from "moment"

// moment() กับค่าว่าง/undefined จะคืน "วันที่ปัจจุบัน" ทำให้วันที่ถูกเปลี่ยนโดยไม่ตั้งใจ
// (เช่น กรณี Trailer ที่ไม่มี ETD POL / Closing Date) จึงต้องเช็ควันที่ฐานก่อนคำนวณทุกครั้ง
const isValidDate = (date) => Boolean(date) && moment(date).isValid()

const SUM_ETD_POL_Pickup_Empty = (ETD, Combine) => {
    const sum = isValidDate(ETD) ? moment(ETD).add(-Combine + 1, 'day').format('yyyy-MM-DD') : ''

    return sum
}
const SUM_ETD_POL_Return_Laden = (Pickup_Empty, Combine) => {
    const sum = isValidDate(Pickup_Empty) ? moment(Pickup_Empty).add(Combine - 1, 'day').format('yyyy-MM-DD') : ''
    return sum
}
const SUM_ETD_POL_Detention = (ETD, Detention) => {
    const sum = isValidDate(ETD) ? moment(ETD).add(-Detention + 1, 'day').format('yyyy-MM-DD') : ''
    return sum
}
const SUM_ETD_POL_Demurrage = (ETD, Demurrage) => {
    const sum = isValidDate(ETD) ? moment(ETD).add(-Demurrage + 1, 'day').format('yyyy-MM-DD') : ''
    return sum
}
const SUM_Closing_Pickup_Empty = (Closing, Combine) => {
    const sum = isValidDate(Closing) ? moment(Closing).add(-Combine + 1, 'day').format('yyyy-MM-DD') : ''
    return sum
}
const SUM_Closing_Return_Laden = (Pickup_Empty, Combine) => {
    const sum = isValidDate(Pickup_Empty) ? moment(Pickup_Empty).add(Combine - 1, 'day').format('yyyy-MM-DD') : ''
    return sum
}
const SUM_Closing_Detention = (Closing, Detention) => {
    const sum = isValidDate(Closing) ? moment(Closing).add(-Detention + 1, 'day').format('yyyy-MM-DD') : ''
    return sum
}
const SUM_Closing_Demurrage = (ETD, Demurrage) => {
    const sum = isValidDate(ETD) ? moment(ETD).add(-Demurrage + 1, 'day').format('yyyy-MM-DD') : ''
    return sum
}
const SUM_Return_Laden_Pickup_Empty = (Actual_date, Combine) => {
    const sum = isValidDate(Actual_date) ?  moment(Actual_date).add(-Combine + 1, 'day').format('yyyy-MM-DD') : ''
    return sum
}
const SUM_Return_Laden_Return_Laden = (Actual_date, Combine) => {
    const sum = isValidDate(Actual_date) ?  moment(Actual_date).add(Combine - 1, 'day').format('yyyy-MM-DD') : ''
    return sum
}
const SUM_Return_Laden_Detention = (Actual_date, Detention) => {
    const sum = isValidDate(Actual_date) ? moment(Actual_date).add(-Detention + 1, 'day').format('yyyy-MM-DD') : ''
    return sum
}
const SUM_Return_Laden_Demurrage = (ETD, Demurrage) => {
    const sum = isValidDate(ETD) ? moment(ETD).add(-Demurrage + 1, 'day').format('yyyy-MM-DD') : ''
    return sum
}


export const SUM_FREETIME = (type, ETD, Closing, Pickup_Empty, Actual_date, Detention, Demurrage, Combine) => {
    let Content;

    console.log(Actual_date);
    switch (type) {
        case "ETD POL_PE":
            Content = SUM_ETD_POL_Pickup_Empty(ETD, Combine)
            break;
    }
    switch (type) {
        case "ETD POL_RL":
            Content = SUM_ETD_POL_Return_Laden(Pickup_Empty, Combine)
            break;
    }
    switch (type) {
        case "ETD POL_DET":
            Content = SUM_ETD_POL_Detention(ETD, Detention)
            break;
    }
    switch (type) {
        case "ETD POL_DEM":
            Content = SUM_ETD_POL_Demurrage(ETD, Demurrage)
            break;
    }
    switch (type) {
        case "Closing_PE":
            Content = SUM_Closing_Pickup_Empty(Closing, Combine)
            break;
    }
    switch (type) {
        case "Closing_RL":
            Content = SUM_Closing_Return_Laden(Pickup_Empty, Combine)
            break;
    }
    switch (type) {
        case "Closing_DET":
            Content = SUM_Closing_Detention(Closing, Detention)
            break;
    }
    switch (type) {
        case "Closing_DEM":
            Content = SUM_Closing_Demurrage(ETD, Demurrage)
            break;
    }
    switch (type) {
        case "Return Laden_PE":
            Content = SUM_Return_Laden_Pickup_Empty(Actual_date, Combine)
            break;
    }
    switch (type) {
        case "Return Laden_RL":
            Content = SUM_Return_Laden_Return_Laden(Actual_date, Combine)
            break;
    }
    switch (type) {
        case "Return Laden_DET":
            Content = SUM_Return_Laden_Detention(Actual_date, Detention)
            break;
    }
    switch (type) {
        case "Return Laden_DEM":
            Content = SUM_Return_Laden_Demurrage(ETD, Demurrage)
            break;
    }
    return Content
}
